export default "assets/images/icons/facebook-ef397d7a.svg";